<template>
    <div class="page6">
        <div class="vip-card">
            <div class="title">
                <div class="card-title">
                    <span>今日已有 </span>
                    <NumScroll :number="number"></NumScroll> 
                    <span>人使用求职金卡找到了工作</span>
                </div>
                <div class="card-desc">开通立即享受12项求职特权</div>
            </div>
            <transition name="trans">
                <div class="vip-cards">
                    <ul class="cards" id="cards">
                        <!--  :class="{active: index === activeIndex}"  -->
                        <li class="card" v-for="(item, index) in cardData" @mouseenter="handleMouseEnter(index)" @mouseleave='handleMouseLeave(index)'>
                            <div class="card-box">
                                <div class="card-title">{{ item.cardTitle }}</div>
                                <!-- hoverIndex == index ? item.hoverText : item.cardDesc -->
                                <div class="card-desc" v-html=" item.hoverText ">
                                </div>
                                <p class="card-price">
                                    <span>￥</span>
                                    <span class="price">{{ item.cardPrice }}</span>
                                    <span class="origin-price">{{ item.originPrice }}</span>
                                </p>
                                <p class="card-discount">
                                    <span class="discount" :class="{'dicount-bg': (item.cardDiscounts === '')}">{{ item.cardDiscounts }}</span>
                                </p>
                                <div class="btn-radiu">
                                    <div class="card-btn" @click="buyVip(item.actionType, item.cardType)">立即开通</div>
                                </div>
                                <!-- <div class="card-valid">有效期{{ item.cardValid }}</div> -->
                            </div>
                            <div :class="{'hot-sell': item.hotSellClass !== ''}"></div>
                        </li>
                    </ul>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import { cardData } from '@/data/data.js';
    import NumScroll from '@/components/numscroll/NumScroll.vue';
    import { mapGetters } from 'vuex'; 

    //开通会员人数接口
    import { getVipBroadcast } from '../../../../api/index.js'

    export default {
        data() {
			return {
                show: true,
                number: 923451,
                numArr:[],
                activeIndex: 0,
                privileges: '',
                hoverIndex: 0,
                cardData
			}
        },
        components:{
            NumScroll
        },
        mounted() {
            this.getVipPerson();
            this.initMealInfo();
            // this.mouseHover();
        },
        methods: {
            // 立即开通按钮 购买vip
            buyVip(actionType, cardType){
                this.$emit('showDialog', cardType);
                window.clickLog && window.clickLog(`from=${actionType}-new`);
            },
            //开通会员人数接口
            getVipBroadcastfn () {
                getVipBroadcast().then((result) => {
                    if (result.isSuccess){
                        this.number = result.entity.num;
                    } else {
                        console.log(result.returnMessage)
                    }
                }).catch((err) => {
                    console.log('网络异常')
                })
            },
            //获取开通会员人数
            getVipPerson(){
                setInterval(this.getVipBroadcastfn, 5000)
            },
            //添加移入移出事件
            // mouseHover(){
            //     var cards = Array.from(document.querySelectorAll('.card'));
            //     cards.forEach((item, index) => {
            //         item.onmouseenter = () => {
            //             document.querySelectorAll('.card')[this.activeIndex].className = 'card';
            //         }
            //         item.onmouseleave = (event) => {
            //             document.querySelectorAll('.card')[this.activeIndex].className = 'card active';
            //         }
            //     })
            // },
            initMealInfo() {
                // 求职会员状态  获取价格
                if(this.mealInfo) {
                    const paySet = this.mealInfo.payset;
                    paySet.forEach((mealItem, index) => {
                        this.cardData[index].cardTitle = mealItem.versionName;
                        this.cardData[index].cardPrice = mealItem.benefitsPrice;
                        this.cardData[index].type = mealItem.vid;
                        this.cardData[index].cardType = mealItem.vid;
                        this.cardData[index].originPrice = mealItem.oldPrice;
                        this.cardData[index].cardDiscounts = mealItem.desc;
                    })
                }
            },
            handleMouseEnter(index) {
                this.hoverIndex = index;
            },
            handleMouseLeave(index) {
                this.hoverIndex = index;
            }
        },
        watch: {
            mealInfo() {
                this.initMealInfo();
            }
        },
        computed: mapGetters({
			mealInfo: 'mealInfo',					// 购买套餐信息
		})
    }
</script>

<style lang="scss" scope>

    .trans-enter-active, .trans-leave-active {
        transition: all .5s;
    }
    .trans-enter, .trans-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .page6{
        height: 100%;
        width: 100%;
        position: relative;
        background: url(../../../../assets/imgs/bg-page4.png) no-repeat center;
        background-size: 100% 100%;
    }
    // DIN字体  base64
    @font-face{
        font-family: 'DIN-Bold';
        src: url(../../../../assets/font/DINBold.ttf);
        font-weight: bold;
        font-style: normal;
    }
    .vip-card{
        width: 1190px;
        height: 650px;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        .title{
            padding-top: 30px;
            margin-bottom: 70px;
            .card-title{
                font-size: 44px;
                color: #FFFFFF;
                letter-spacing: 0;
                text-align: center;
            }
            .vip-person{
                display: inline-block;
                width: 180px;
                height: 50px;
                overflow: hidden;
                vertical-align: middle;
                padding-left: 25px;
                .inblock{
                    float: left;
                    width: 30px;
                    font-size: 46px;
                    color: #E6CA99;
                    letter-spacing: 0;
                    text-align: center;
                    /* 书写模式*/
                    writing-mode: vertical-rl;
                    /* 控制行内字符的旋转*/
                    text-orientation: upright;
                    margin-top: 0em; 
                    -webkit-transition: margin-top .5s ease-out;
                    -o-transition: margin-top .5s ease-out;
                    transition: margin-top .5s ease-out;

                    &.util{
                        margin-top: 0;
                    }
                    &.decade{
                        margin-top: 0;
                    }
                    &.hundred{
                        margin-top: 0;
                    }
                    &.thousand{
                        margin-top: 0;
                    }
                    &.tenTh{
                        margin-top: 0;
                    }
                    &.lakh{
                        margin-top: 0;
                    }
                }
            }
            .card-desc{
                opacity: 0.5;
                font-size: 20px;
                color: #FFFFFF;
                text-align: center;
                margin-top: 10px;
            }
        }
        .vip-cards{
            width: 100%;  
            height: 400px;
            margin: 0 auto;
            margin-top: 100px;
            .cards{
                text-align: center;
                .card-box {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 100%;
                }
                .card{
                    position: relative;
                    display: inline-block;
                    width: 273px;
                    height: 340px;
                    background: rgba(64,60,54,0.48);
                    border: 1px solid rgba(219,176,110,0.28);
                    border-radius: 8px;
                    margin-right: 20px;
                    transition: all .3s;
                    position: relative;
                    .card-title{
                        font-size: 22px;
                        color: #E6CA99;
                        text-align: center;
                        line-height: 28px;
                        margin: 25px 0 6px 0;
                        transition: all .3s;
                    }
                    .card-desc {
                        opacity: 0.5;
                        font-size: 14px;
                        color: #E6CA99;
                        text-align: center;
                        height: 20px;
                        overflow: hidden;
                        transition: all .3s;
                    }
                    .card-price{
                        font-size: 20px;
                        color: #FFFFFF;
                        text-align: center;
                        margin: 35px 0 0px 0;
                        transition: margin .3s;
                        .price{
                            font-size: 50px;
                            color: #FFFFFF;
                            line-height: 24px;
                        }
                        .origin-price{
                            opacity: 0.5;
                            font-size: 20px;
                            color: #999999;
                            line-height: 18px;
                            text-decoration: line-through;
                        }
                    }
                    .card-discount{
                        text-align: center;
                        .discount{
                            background: #FFDC76;
                            font-size: 12px;
                            color: #8B610B;
                            text-align: center;
                            padding: 0 6px;
                        }
                        .dicount-bg{
                            background: rgb(49,46,43);
                        }
                    }
                    .btn-radiu{
                        width: 128px;
                        height: 40px;
                        border-radius: 100px;
                        margin: 0 auto;
                        line-height: 40px;
                        overflow: hidden;
                        margin-top: 31px;
                    }
                    .card-btn{
                        width: 128px;
                        height: 40px;
                        font-size: 14px;
                        color: #32302E;
                        text-align: center;
                        line-height: 40px;
                        filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#E2C590",endColorStr="#CCA768",gradientType="0");
                        background-image: linear-gradient(-212deg, #E2C590 0%, #CCA768 100%);
                        box-shadow: 0 7px 10px -7px #D5B16D, 0 15px 16px -4px #140D02;
                        border-radius: 100px;
                    }
                    .card-valid{
                        opacity: 0.5;
                        font-size: 14px;
                        color: #E6CA99;
                        text-align: center;
                        margin-top: 15px;
                    }
                    .hot-sell{
                        position: absolute;
                        top: 0;
                        left: 20px;
                        display: inline-block;
                        width: 40px;
                        height: 40px;
                        background: url(../../../../assets/imgs/vipCard-hot.png) no-repeat;
                        background-size: 40px 40px;
                    }
                    &:hover{
                        padding: 20px 5px;
                        margin: -20px 15px -20px -5px;
                        background-image: linear-gradient(-181deg, #3C3528 1%, #272015 92%);
                        border: 1px solid rgba(219,176,110,0.50);
                        box-shadow: 0 17px 22px -20px #746242, 0 20px 20px 6px #1D1403;
                        border-radius: 8px 12px 12px 12px;
                        cursor: pointer;
                        .card-title{
                            margin-top: 15px;
                        }
                        .card-desc {
                            padding-bottom: 100px;
                        }
                        .card-price {
                            margin-top: 20px;
                        }
                        .dicount-bg{
                            background: #2F281D;
                        }
                    }
                    &.active{
                        padding: 20px 5px;
                        margin: -20px 15px -20px -5px;
                        background-image: linear-gradient(-181deg, #3C3528 1%, #272015 92%);
                        border: 1px solid rgba(219,176,110,0.50);
                        box-shadow: 0 17px 22px -20px #746242, 0 20px 20px 6px #1D1403;
                        border-radius: 8px 12px 12px 12px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// VipCard.vue?1b75cee0